jQuery(document).ready(function($) {

	$.search = {
		init: function() {
			$.search.events();
		},

		events: function() {

			$(document).on('click', '.m-search-form__button', function(e) {
				var searchWrapper = $('.m-search-form__outer');
				var oSearch = $('.m-search-form');

				searchWrapper.toggleClass('active');

				oSearch.css('display', 'block');

				oSearch.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function() {
					$('.m-search-form__input').focus();

					if (!searchWrapper.hasClass('active')) {
						oSearch.css('display', 'none')
					}
				});
			});

			$(document).on('click', '.m-search-content__form__submit', function(e) {
				var form = $('.m-search-content__form');
				var input = $('.m-search-content__form input');

				if (input.val() !== "") {
					form.submit();
				}
			});

		},
	}

});